import React from 'react';
import PropTypes from 'prop-types';
import { BlipSearchComponent } from './BlipSearchComponent';

const BlipSearchContainer = ({
  onChange,
  debounce,
  search,
  placeholder,
}) => {
  return <BlipSearchComponent
    onChange={onChange}
    debounce={debounce || 0}
    search={search}
    placeholder={placeholder}
  />;
};

BlipSearchContainer.propTypes = {
  onChange: PropTypes.func.isRequired,
  debounce: PropTypes.number,
};

export { BlipSearchContainer };
